import React from "react";
import { makeStyles } from "@material-ui/core";
import { useTranslation } from "react-i18next";

import {
  h4Medium,
  h5Medium,
  h6Regular,
  pointer,
} from "../../../shared/constants";

const useStyles = makeStyles({
  container: {
    background: "#FFFFFF",
    width: "100%",
    padding: "48px 0",
    borderRadius: 32,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
    margin: "0 auto",
    maxWidth: 640,
  },
  title: {
    ...h4Medium,
    "@media (max-width:940px)": {
      ...h5Medium,
    },
  },
  subTitle: {
    ...h6Regular,
    marginTop: 16,
    padding: "0 24px",
    textAlign: "center",
  },
  button: {
    height: 56,
    width: "100%",
    maxWidth: 320,
    border: "none",
    textAlign: "center",
    background: "#80BB34",
    borderRadius: 16,
    marginTop: 24,
    ...h5Medium,
    color: "#FFFFFF",
    ...pointer,
  },
});

const PaymentError = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  return (
    <>
      <div style={{ paddingTop: 144 }}></div>
      <div className={classes.container}>
        <span className={classes.title}>{t("checkout.paymentError")}</span>
        <span className={classes.subTitle}>{t("checkout.paymentErrorMsg")}</span>
        <button
          className={classes.button}
          onClick={() => {
            window.location = "/checkout";
          }}
        >
          {t("checkout.backToCheckout")}
        </button>
      </div>
    </>
  );
};

export default PaymentError;
